import { NOT_SET } from '@sunrise/tracking'

import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'
import { BookmarkListAction, BookmarkListBodyType } from '../../ts/utils/trackingUtils.enum'

export function buildTealiumRestoreBookmarkData() {
    return {
        mslayer_element_body_type: BookmarkListBodyType.TOAST,
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_data_id: TealiumTrackingIds.BOOKMARK_LIKE_AND_REMOVE_AND_REVERT_CLICK,
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_id: NOT_SET,
        mslayer_element_type_text: 'Merkliste',
        mslayer_element_position: NOT_SET,
        mslayer_element_text: BookmarkListAction.RESTORE,
        mslayer_element_variant: 'default',
    }
}
